// Badge y helpers de badge (port de badgeHTML/nivelBadge/estadoBadge/tipoBadge).
import type { ReactNode } from 'react';
import type { NivelStock, Estado } from '../types';

export type BadgeType = 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'neutral';

export function Badge({ children, type = 'neutral', dot = true }: { children: ReactNode; type?: BadgeType; dot?: boolean }) {
  return (
    <span className={`badge ${type}`}>
      {dot ? <span className="dot" /> : null}
      {children}
    </span>
  );
}

export function NivelBadge({ nivel }: { nivel: NivelStock }) {
  if (nivel === 'agotado') return <Badge type="danger">Agotado</Badge>;
  if (nivel === 'bajo') return <Badge type="warning">Stock bajo</Badge>;
  return <Badge type="success">Disponible</Badge>;
}

export function EstadoBadge({ estado }: { estado: Estado }) {
  return estado === 'Inactivo' ? <Badge type="neutral">Inactivo</Badge> : <Badge type="success">Activo</Badge>;
}

// Colorea el badge según el tipo de movimiento (mismos prefijos que el original).
const TIPO_MAP: Record<string, BadgeType> = {
  Entrada: 'success',
  Salida: 'danger',
  Traslado: 'primary',
  Fabricación: 'success',
  Desfabricación: 'warning',
  'Ajuste manual': 'info',
};

export function TipoBadge({ tipo }: { tipo: string }) {
  const clave = Object.keys(TIPO_MAP).find((k) => (tipo || '').indexOf(k) === 0);
  return <Badge type={clave ? TIPO_MAP[clave] : 'neutral'}>{tipo || '—'}</Badge>;
}
